import {DetailsPageComponents} from '@stencil/omniture-analytics/src/constants/details';
import useOmnitureLoaded from '@stencil/omniture-analytics/src/hooks/useOmnitureLoaded';

import HighlightFeatureCardUI from '@stencil/gi-components/src/HighlightFeatureCardUI/HighlightFeatureCardUI';

import * as S from './PropertyHighlights.styles';

const PropertyHighlights = ({
  numItemsHtlDesc,
  numLinesHtlDesc,
  premiumUsp = {},
  propertyType = '',
}) => {
  useOmnitureLoaded(DetailsPageComponents.propertyHighlights);

  return (
    <S.PropertyHighlightsWrapper>
      <S.PropertyHighlightsHeader>About the {propertyType}</S.PropertyHighlightsHeader>
      <S.PropertyHighlightsBody>
        <S.PropertyHighlightsDesc>{premiumUsp?.summary}</S.PropertyHighlightsDesc>
        <S.FeatureList>
          {premiumUsp?.highlights
            ?.slice(0, numItemsHtlDesc)
            .map(item => (
              <HighlightFeatureCardUI
                key={item?.key}
                icon={item?.iconUrl}
                description={item?.description}
                numberOfLines={numLinesHtlDesc}
              />
            ))}
        </S.FeatureList>
      </S.PropertyHighlightsBody>
    </S.PropertyHighlightsWrapper>
  );
};

export default PropertyHighlights;
